// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".truncate-string[data-v-a915070a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.truncate-string > span[data-v-a915070a] {\n  white-space: nowrap;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
